// src/components/HeadingWithWatermark.jsx
import React from 'react';

const HeadingWithWatermark = ({ 
  title = "NEWSLETTER", 
  watermarkText = "WATERMARK",
  color = "#1b73a7",
  titleSize = "text-3xl md:text-4xl lg:text-5xl",
  watermarkSize = "text-6xl md:text-8xl lg:text-9xl",
  align = "center",
  className = "",
  showLine = true
}) => {
  const alignmentClasses = {
    left: "text-left",
    center: "text-center mx-auto",
    right: "text-right ml-auto"
  };

  return (
    <div className={`relative py-4 md:py-7 mb-3 md:mb-4 overflow-hidden ${className}`}>
      {/* Watermark Background */}
      <div 
        className={`absolute top-1/2 -translate-y-1/2 font-black tracking-wider opacity-10 whitespace-nowrap select-none ${watermarkSize} ${
          align === 'center' ? 'left-1/2 -translate-x-1/2' : 
          align === 'right' ? 'right-0' : 'left-0'
        }`}
        style={{ color: color }}
      >
        {watermarkText}
      </div>
      
      {/* Main Heading */}
      <div className={`${alignmentClasses[align]} relative z-10`}>
        <h1 
          className={`${titleSize} font-bold tracking-tight mb-4`}
          style={{ color: color }}
        >
          {title}
        </h1>
        
        {/* Decorative Line - Optional */}
        {showLine && (
          <div 
            className={`h-1 ${align === 'center' ? 'mx-auto' : align === 'right' ? 'ml-auto' : 'mr-auto'}`}
            style={{ backgroundColor: color, width: '60px' }}
          ></div>
        )}
      </div>
    </div>
  );
};

export default HeadingWithWatermark;